// ألوان الإطار لكل نوع - نفس القائمة المستخدمة بواجهة الفاتورة (InvoicePage.jsx)
// وبفورم "طلب جديد" مال ارت تاتش (PartnerAddOrder.jsx)، حتى القيم المخزّنة
// بالفاتورة تبقى مطابقة لخيارات الواجهة عند التعديل.
export const FRAME_COLORS = {
  L: [
    "اطار-ال-شامبان-خشن",
    "اطار-ال-قهوائي-خشن",
    "اطار-ال-ناعم-شامباني",
    "اطار-ال-ناعم-فضي",
    "اطار-ال-ناعم-اسود-مشطب",
  ],
  Kas: [
    "اطار-كاس-اسود-خشن",
    "اطار-كاس-خشتي-فاتح",
    "اطار-كاس-خشن-ذهبي",
    "اطار-كاس-خشن-شامباني",
    "اطار-كاس-خشن-فضي",
    "اطار-كاس-خشن-قهوائي-طوخ",
    "اطار-كاس-خشن-قهوائي-فاتح",
    "اطار-كاس-ناعم-ذهبي-مشطب",
    "اطار-كاس-ناعم-شامباني",
  ],
};

// أنواع الإطار المتاحة لارت تاتش (بدون "أخرى") - مودرن = أيل، كلاسك = كاس
export const PARTNER_FRAME_TYPES = [
  { value: "L", label: "مودرن (L Frame)" },
  { value: "Kas", label: "كلاسك (Kas Frame)" },
];

// قياسات اللوحة الجاهزة - نفس قائمة القياسات بالفاتورة (InvoicePage.jsx)
export const PARTNER_SIZE_OPTIONS = [
  "30x30", "30x40", "40x40", "40x60", "50x50", "50x70", "60x60", "60x80",
  "70x70", "70x100", "80x80", "80x120", "90x90", "100x100", "110x110",
  "120x120", "120x180", "130x130", "160x240",
];

// شكل اللوحة - نفس قائمة PANEL_SHAPES بالفاتورة
export const PANEL_SHAPES = ["لوحة مربعة", "لوحة مستطيلة أفقية", "لوحة مستطيلة عمودية"];

// اسم اللون للعرض: "اطار-كاس-خشن-ذهبي" ← "اطار كاس خشن ذهبي"
export const formatFrameColor = (color) => String(color || "").replace(/-/g, " ");
